import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { useNotification } from '@hero/store/hooks';

export function NetworkCheckerProvider() {
  const { t } = useTranslation();

  const { showSuccess, showWarning } = useNotification();

  useEffect(() => {
    const handleOnline = () => {
      toast.dismiss();
      showSuccess({
        message: t('network.reconnected'),
        type: 'toast'
      });
    };

    const handleOffline = () => {
      showWarning({
        message: t('network.disconnected'),
        type: 'toast',
        toastOptions: {
          duration: Infinity
        }
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    if (!navigator.onLine) {
      showWarning({
        message: t('network.offline'),
        type: 'toast'
      });
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return null;
}
